import React, { Component } from 'react';
const products = [{
  name: 'CHMER H32Z',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/fc75be84df3e30cde153d25028eb0ba1/large-chmer-znc-series-h32-z.jpg',
  href: '/listings/4738652-chmer-znc-series-h32z'
}, {
  name: 'CHMER H43Z',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/1100d5e5b0cae690ca6ed4c900f3169e/large-chmer-znz-series-h32-z.jpg',
  href: '/listings/5562812-chmer-h43z-znc-driller'
}, {
  name: 'CHMER H54Z',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/21cb16fe152ac6caa9432014915b2059/large-0001811_chmer-znz-series-h54z.jpg',
  href: '/listings/4738654-chmer-h54z-znc-driller'
}, {
  name: 'CHMER H75Z',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/a944effe907b86981010f3fb8db59475/large-0001810_chmer-znz-series-h75z.jpg',
  href: '/listings/4738655-chmer-znc-series-h54z'
}];
export function ChmerZNCSection() {
  return <section data-id="element-1811">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-1812">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-1813">
          Chmer ZNC Series
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-1814">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1815">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1816">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-1817">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-1818" />
              </a>
              <div className="p-5 flex flex-col flex-grow" data-id="element-1819">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-1820">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-1821">
                    {product.name}
                  </h3>
                </a>
                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-1822">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-1823">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-1824">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}